<template>
  <div class="enterprise-list">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange == 'en' ? 'Product List' : '产品列表'"
        name="productList"
      >
        <div class="table-box">
          <div class="table-title">
            <el-input
              size="mini"
              :placeholder="
                $lange == 'en' ? 'Please input Product Name' : '请输入产品名称'
              "
              v-model="productTableParams.name"
            ></el-input>
            <el-button
              class="button"
              type="primary"
              size="mini"
              @click="doSearch"
              >{{ $lange == "en" ? "Search" : "搜索" }}</el-button
            >
            <el-button
              size="mini"
              type="primary"
              style="margin-left: auto"
              @click="addProduct"
              class="button"
              >{{ $lange == "en" ? "Add" : "添加" }}</el-button
            >
          </div>
          <cc-table
            :config="productTableConfig"
            :params="productTableParams2"
            :refesh-params="refeshTable"
          ></cc-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="editItemFlag ? dialogTitles[0] : dialogTitles[1]"
      :visible.sync="formFlag"
      width="60%"
      @close="dialogClose"
      append-to-body
    >
      <el-form :model="form" size="mini" label-width="150px">
        <el-form-item
          :label="$lange == 'en' ? 'Product Category' : '产品分类'"
          required="true"
        >
          <el-select
            v-model="form.classId"
            :placeholder="$lange == 'en' ? 'Please Select' : '请选择'"
            clearable
          >
            <el-option
              v-for="item in productSelector"
              :key="item.id"
              :label="`${item.title}(${item.lange})`"
              :value="item.id"
              :useSuccess="true"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="$lange == 'en' ? 'Product Name' : '产品名字'"
          required="true"
        >
          <div style="max-width: 195px">
            <el-input
              v-model="form.name"
              :placeholder="$lange == 'en' ? 'Please Input' : '请输入'"
            ></el-input>
          </div>
        </el-form-item>

        <el-form-item
          :label="$lange == 'en' ? 'Product Information' : '产品信息'"
          style="height: 300px"
        >
          <cc-editor v-model="form.content"></cc-editor>
        </el-form-item>

        <el-form-item :label="$lange == 'en' ? 'Product Images' : '产品图片'">
          <div>
            <!-- <div
              class="list"
              v-for="(item, idx) in imageArr"
              :style="`background: url(${item.accessoryUrl}) no-repeat center / cover`"
              @click="showMediaFun(item.accessoryUrl, 'image')"
            >
              <div class="del-image flex-between" @click.stop="delImage(idx)">
                X
              </div>
            </div> -->
            <!-- <div class="list">
              <cc-uploader
                :config="uploaderConf2"
                uploadType="dottedLine"
                :useSuccess="true"
                :isMultiple="true"
                @upload-success="uploadTrue"
              />
            </div> -->
            <div v-for="(item, idx) in imageArr" style="margin-bottom: 10px;">
              <cc-uploader
                :config="uploaderConf2"
                fType="image"
                :fFormat="['image/jpeg','image/png']"
                v-model="item.accessoryUrl"
                tipsText="只能上传jpeg,png文件"
                :index="index"
                @upload-success2="uploadTrue"
              />
            </div>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              size="mini"
              @click="addImgList"
              >添加</el-button
            >
          </div>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Upload Video' : '上传视频'"
          prop="salePrice"
        >
          <div class="uploader_icon">
            <cc-uploader
              :config="uploaderConf2"
              fType="video"
              :fFormat="['video/mp4']"
              v-model="form.productVideoUrl"
              tipsText="只能上传mp4文件"
            />
          </div>
          <!-- <div class="video-upload-box">
            <template v-if="form.productVideoUrl == ''">
              <cc-uploader
                :config="uploaderConf2"
                uploadType="dottedLine"
                v-model="form.productVideoUrl"
                @upload-success="uploadVideoTrue"
              />
            </template>
            <div
              class="video-url"
              @click.stop="showMediaFun(form.productVideoUrl, 'video')"
              v-else
            >
              <i
                class="icon del-icon el-icon-close"
                @click.stop="form.productVideoUrl = ''"
              ></i>
              <img class="icon icon-play" :src="videoPlayIcon" alt />
            </div>
          </div> -->

          <!--                    productVideoUrl-->
        </el-form-item>

        <el-form-item :label="$lange == 'en' ? 'Status' : '状态'">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">Show</el-radio>
            <el-radio :label="1">Hide</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitAddProduct('formRule')">{{
            $lange == "en" ? "Submit" : "提交"
          }}</el-button>
          <el-button @click="formFlag = false">{{
            $lange == "en" ? "Cancel" : "取消"
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showMediaFlag" width="80%" append-to-body>
      <img
        style="display: block; margin: 0 auto; max-width: 100%"
        :src="showMediaUrl"
        v-if="showMediaType === 'image'"
        alt
      />
      <video
        style="display: block; margin: 0 auto; width: 80%; height: 400px"
        :src="showMediaUrl"
        controls
        v-else
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import videoPlayIcon from "../../assets/icon-video-play.png";
import moment from "moment";
export default {
  name: "EnterpriseList",
  data() {
    return {
      dialogTitles: ["编辑产品", "添加产品"],
      showMediaFlag: false,
      showMediaType: "image",
      showMediaUrl: "",
      uploaderConf2: this.$uploadUtils.config,
      videoPlayIcon: videoPlayIcon,
      dialogTitle: "添加产品",
      formRule: "",
      form: {
        classId: "",
        name: "",
        content: "",
        productVideoUrl: "",
        uploadUrl: "",
        status: 0,
        batchFileInfoList: [],
      },
      formFlag: false,

      editItemFlag: false,
      editItemData: {},
      editItemIndex: false,

      activeName: "productList",
      productSelector: [],
      productTableConfig: {
        api: "admin/fsb/enterprise/product/query",
        showPager: true,
        showIndex: true,
        columns: [
          {
            prop: "enterpriseProductClass.title",
            lable: "产品分类",
            render: (row) => {
              if (
                row.enterpriseProductClass &&
                row.enterpriseProductClass.title
              ) {
                return `${row.enterpriseProductClass.title} (${row.enterpriseProductClass.lange})`;
              } else {
                return "";
              }
            },
          },
          {
            prop: "name",
            lable: "产品名字",
          },
          {
            prop: "status",
            lable: "状态",
            type: "tag",
            options: [
              { tagType: "success", text: "显示" },
              { tagType: "info", text: "不显示" },
            ],
          },

          {
            lable: "创建时间",
            render: (row) => {
              return moment(row.createTime).format("YYYY-MM-DD");
            },
          },
        ],
        buttons: [
          {
            name: "编辑",
            click: (row) => {
              for (let i in this.form) {
                this.form[i] = row[i];
              }
              this.form.id = row.id;
              this.editItemData = row;
              this.editItemFlag = true;
              this.formFlag = true;
              this.imageArr = row.batchFileInfoList;
            },
          },
          {
            name: "删除",
            click: (row) => {
              this.$confirm("此操作会删除该产品, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                let data = {
                  id: row.id,
                };
                this.ccRequest
                  .do("admin/fsb/enterprise/product/delete", data, "GET")
                  .then((res) => {
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                    this.refeshTable = new Date().getTime();
                  });
              });
            },
          },
        ],
      },
      productTableParams: {
        name: "",
      },
      refeshTable: -1,
      imageArr: [],
      productTableParams2: {
        name: "",
      },
    };
  },
  methods: {
    doSearch() {
      this.productTableParams2 = { ...this.productTableParams };
    },
    delImage(idx) {
      this.imageArr.splice(idx, 1);
    },
    addImgList(){
          this.imageArr.push({
        accessoryUrl: "",
        fileName: "",
      });
    },
    dialogClose() {
      this.refeshTable = new Date().getTime();
      this.form = {
        classId: "",
        name: "",
        content: "",
        productVideoUrl: "",
        status: 0,
        batchFileInfoList: [],
      };
      this.imageArr = [];
      console.log("clear");
    },
    submitAddProduct() {
      let batchFileInfoList=[]
      for (let index = 0; index < this.imageArr.length; index++) {
        if(this.imageArr[index].accessoryUrl){
            batchFileInfoList.push(this.imageArr[index])
        }        
      }
      let data = this.form;
      data.batchFileInfoList = batchFileInfoList;
      console.log(data)
      this.ccRequest
        .do("admin/fsb/enterprise/product/save", data, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "提交成功",
          });
          this.editItemFlag = false;
          this.formFlag = false;
        });
    },
    showMediaFun(url, type) {
      this.showMediaFlag = true;
      this.showMediaType = type;
      this.showMediaUrl = url;
    },
    uploadTrue(res,index) {
      this.imageArr[res.index].fileName=res.fileName;
      console.log(this.imageArr)
      // this.imageArr.push({
      //   accessoryUrl: res.accessoryUrl,
      //   fileName: res.fileName,
      // });
    },
    uploadVideoTrue(res) {
      this.form.productVideoUrl = res;
    },
    addProduct() {
      this.dialogTitle = "添加产品";
      this.formFlag = true;
    },
    productSelectorData() {
      this.ccRequest
        .do("admin/fsb/enterprise/product/class/query", {}, "GET")
        .then((res) => {
          this.productSelector = res.rows;
        });
    },
    getData() {
      this.productSelectorData();
    },
    checkLanguage() {
      if (this.$lange == "en") {
        this.productTableConfig = {
          api: "admin/fsb/enterprise/product/query",
          showPager: true,
          showIndex: true,
          columns: [
            {
              prop: "enterpriseProductClass.title",
              lable: "Product Classification",
            },
            {
              prop: "name",
              lable: "Product Name",
            },
            {
              prop: "status",
              lable: "Status",
              render: (row) => {
                return ["show", "hide"][row.status];
              },
            },

            {
              lable: "Create time",
              render: (row) => {
                return moment(row.createTime).format("YYYY-MM-DD");
              },
            },
          ],
          buttonsLabel: "Operation",
          buttons: [
            {
              name: "Edit",
              click: (row) => {
                for (let i in this.form) {
                  this.form[i] = row[i];
                }
                this.form.id = row.id;
                this.editItemData = row;
                this.editItemFlag = true;
                this.formFlag = true;
              },
            },
            {
              name: "Delete",
              click: (row) => {
                this.$confirm("此操作会删除该产品, 是否确定?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }).then(() => {
                  let data = {
                    id: row.id,
                  };
                  this.ccRequest
                    .do("admin/fsb/enterprise/product/delete", data, "GET")
                    .then((res) => {
                      this.$message({
                        type: "success",
                        message: "删除成功",
                      });
                      this.refeshTable = new Date().getTime();
                    });
                });
              },
            },
          ],
        };
        this.dialogTitles = ["Edit Product", "Add Product"];
      }
    },
  },
  mounted() {
    this.getData();
    this.checkLanguage();
  },
};
</script>

<style lang="scss">
.image-lists .dottedUpload,
.video-upload-box .dottedUpload {
  min-width: 80px;
}
</style>
<style scoped lang="scss">
.button {
  margin: 0 10px;
}
.enterprise-list {
  .table-title {
    width: 100%;
    padding: 20px 20px 0 20px;
    margin-bottom: 20px;
    box-sizing: border-box;
    > *:first-child {
      width: 200px;
    }
  }
  .image-lists {
    justify-content: flex-start;
    flex-wrap: wrap;
    > div:not(:last-child) {
      margin-right: 10px;
      border: 1px dotted #e4e4e4;
    }
    .list {
      width: 80px;
      height: 80px;
      border-radius: 3px;
      position: relative;
      cursor: pointer;
      .del-image {
        position: absolute;
        border-radius: 50%;
        border: 1px solid #f00;
        color: #f00;
        width: 20px;
        height: 20px;
        justify-content: center;
        text-align: center;
        right: 0;
        top: 0;
        transform: translateY(-50%) translateX(50%);
      }
    }
  }
  .video-upload-box {
    border: 1px dotted #e4e4e4;
    position: relative;
    cursor: pointer;
    width: 80px;
    height: 80px;
    border-radius: 3px;
    background: #6f6f6f;
    .icon {
      position: absolute;
      right: 0;
      top: 0;
      transform: translateY(-50%) translateX(50%);
      &.del-icon {
        z-index: 99;
        width: 15px;
        height: 15px;
        color: #f56c6c;
        border-radius: 50%;
        border: 1px solid #f56c6c;
        font-size: 13px;
        line-height: 15px;
        text-align: center;
      }
      &.icon-play {
        bottom: 0;
        left: 0;
        transform: translateY(0) translateX(0);
        margin: auto;
      }
    }
    > div {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style>
.uploader_icon .file-icon button {
  position: relative;
  top: -7px;
}
</style>